<template>
  <Dialog
    v-if="quoteUserMessages?.quote_user_messages"
    v-model:visible="isVisible"
    maximizable
    modal
    header="Quote Admin Notifications"
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <div v-for="msg in quoteUserMessages.quote_user_messages" :key="msg.id">
      <h3>
        {{ msg?.title }} |
        {{ new Date(msg?.created_at)?.toLocaleDateString("en-US") }}
      </h3>
      <p class="m-0">
        {{ msg?.message }}
      </p>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { useGetQuoteUserMessagesQuery } from "gql/api";
import { ref, watchEffect } from "vue";

const { data: quoteUserMessages } = useGetQuoteUserMessagesQuery({
  requestPolicy: "network-only",
  variables: {}
});

const isVisible = ref(false);
watchEffect(() => {
  if (quoteUserMessages.value?.quote_user_messages.length)
    isVisible.value = true;
});
</script>
